/**
 * Cross-realm-safe check for a thenable (Promise-like) value, without `instanceof`.
 * Used to detect when a row/bulk action handler returned a Promise so its lifecycle
 * (lock, loading flag) can be tracked.
 */
export const isThenable = (value: unknown): value is PromiseLike<unknown> =>
  value != null && typeof (value as {then?: unknown}).then === 'function';
